export default __webpack_public_path__ + "media/Dry-Food-Rice.efbc37bf.png";